import { render, staticRenderFns } from "./collapse-plus.vue?vue&type=template&id=3bf7e250&scoped=true"
import script from "./collapse-plus.vue?vue&type=script&lang=js"
export * from "./collapse-plus.vue?vue&type=script&lang=js"
import style0 from "./collapse-plus.vue?vue&type=style&index=0&id=3bf7e250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7e250",
  null
  
)

export default component.exports